function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m0 .3v23.4h24v-23.4zm1 1h22v21.4h-22zm5.648 15.325c-.116 0-.148-.05-.148-.148v-10.744c0-.083.033-.132.116-.132h1.584c.084 0 .1.037.1.12v9.26h4.125c.083 0 .106.033.09.116l-.248 1.42c-.016.082-.066.115-.148.115h-5.469zm7.402-6.476c0-.12 0-.416-.05-.977 0-.083.018-.1.084-.132.61-.246 2.058-.692 3.675-.692.08 0 .112.017.112.1v1.452c0 .084-.033.1-.116.1-.628-.033-1.564.05-1.91.198v6.31c0 .082-.033.115-.116.115h-1.57c-.08 0-.114-.033-.114-.116v-6.36z"
});

var SvgAdobelightroomclassic = function SvgAdobelightroomclassic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdobelightroomclassic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "adobelightroomclassic.svg";
export { ForwardRef as ReactComponent };